import Axios from 'axios'
import store from '../store'

export default {
  getClientId () {
    return store.getters['Client/clientId']
  },
  searchUsers (query) {
    return Axios.get(`/api/external/clients/${this.getClientId()}/users?searchFilter=${query}`)
  }
}
